import CONFIG from "./../config.json";
import {browserGetCookie, browserSetCookie} from "./browser.js" ;
const COOKIE_NAME = "subscription-src";




function subscriptionSendNewConnection() {

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    // send one a day   
    if (!token && browserGetCookie(COOKIE_NAME))
        return;

    browserSetCookie(COOKIE_NAME, "posters", 1);
    
    const url = `${CONFIG.subscription_url}/api/user/posters/visit`;
    if (token) url.searchParams.append("token", token);    

    try {
        fetch(url, {
            method: "GET",
            credentials: 'include'
        });
    } catch (e) {
        Log.print('Subscription Send New Connection Error:' + e);
    }

}


function subscriptionLoadForm() {
    const mainSubscriptionDiv = document.getElementById('mainSubscription');

    if (!mainSubscriptionDiv)
        return;

    mainSubscriptionDiv.innerHTML = `
        <div class="subscription-container">
            <div id="subscription-title">Segueix-nos</div>
            <form id="subscription-form">                
                <input type="email" id="email" name="email" placeholder="el teu email" required>
                <button type="button" id="subscribe-button">Subscriu-te</button>
            </form>
        </div>

        <!-- Pop-up Modal -->
        <div id="subscription-modal" class="subscription-modal">
            <div class="subscription-modal-content">                     
                <div>T'estàs subscribint a Cartells de Ponent.</div> 
                <div>T'enviarem un correu electrònic de verificació.</div> 
                <div>Vols continuar?</div>    
                <div style="margin-top:1em;";>
                  <button id="subscription-confirm-button">OK</button>
                  <button id="subscription-cancel-button">Cancel</button>
                </div>
            </div>
        </div>
    `;

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    document.getElementById("subscribe-button").addEventListener("click", function () {
        const email = document.getElementById("email").value;

        if (emailPattern.test(email)) {
            document.getElementById("subscription-modal").style.display = "flex";
        } else {
            alert("L'email no és vàlid.");
        }
    });

    document.getElementById("subscription-confirm-button").addEventListener("click", function () {
        const email = document.getElementById("email").value;

        document.getElementById("subscription-modal").style.display = "none";

        fetch(`${CONFIG.subscription_url}/api/subscription/petition`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                to: email
            })
        })
                .then(response => response.json())
                .then(data => {
                    console.log("Molt bé: " + data.message);
                })
                .catch(error => {
                    console.log("Hi ha hagut algun problema: " + error);
                });
    });

    document.getElementById("subscription-cancel-button").addEventListener("click", function () {
        document.getElementById("subscription-modal").style.display = "none";
    });
}


export { subscriptionSendNewConnection, subscriptionLoadForm };
